import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getMobileListingData
} from "./thunk";
export const initialState = {
    data: [],
    error: "", // for error message
    loading: false,
};

const mobileViewListing = createSlice({
    name: "mobileListing",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getMobileListingData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMobileListingData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getMobileListingData.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
                state.message = "No data added";
            })

    }
});


export default mobileViewListing.reducer;